











import './KisweForm.scss'
import { defineComponent } from '@vue/composition-api'
import useFlexbox from '../../../compositions/flexbox'

export default defineComponent({
  name: 'KisweForm',
  props: {
    hasSeparators: {
      type: Boolean,
      required: false,
      default: false
    },
    ...useFlexbox().props
  },
  methods: {
    submitted (event: Event) {
      this.$emit('submit', event)
    }
  }
})
